import React, { useState, useEffect } from 'react';
import CommonModal from '../common/commonModal/CommonModal';
import { yearCrud } from '../../api/yearApi';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import validateFields from '../ValidationChecker';
import { FaRegCalendar } from "react-icons/fa6"; // Assuming this icon is desired

const YearModal = ({ show, onHide, initialData, onSaveSuccess }) => {
    const [modalMode, setModalMode] = useState('add');
    const [modalData, setModalData] = useState({ year: '' });
    const [initialModalState, setInitialModalState] = useState({ year: '' });
    const [errors, setErrors] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const columns = [
        { header: 'Time Period', accessor: 'year', type: 'text', placeholder: `e.g. Q1'24 or 2023`, required: true },
    ];

    useEffect(() => {
        if (show) {
            if (initialData && initialData.id) {
                setModalMode('edit');
                const data = { id: initialData.id, year: initialData.year || '' };
                setModalData(data);
                setInitialModalState(data);
            } else {
                setModalMode('add');
                const emptyData = { year: '' };
                setModalData(emptyData);
                setInitialModalState(emptyData);
            }
            setErrors({});
            setIsChanged(false);
        }
    }, [show, initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setModalData((prev) => {
            const updated = { ...prev, [name]: value };
            setIsChanged(JSON.stringify(updated) !== JSON.stringify(initialModalState));
            return updated;
        });
    };

    const handleSave = () => {
        const validationFields = columns.map(c => ({ name: c.accessor, required: c.required }));
        const { isValid, errors: validationErrors } = validateFields(modalData, validationFields);

        if (isValid) {
            setIsSaving(true);
            const method = modalMode === 'add' ? 'post' : 'put';

            yearCrud(modalData, method, (res) => {
                setIsSaving(false);
                if (res?.status === true || res?.status === 200) {
                    ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                    if (onSaveSuccess) {
                        onSaveSuccess();
                    }
                    onHide();
                } else {
                    if (res?.data?.errors) {
                        setErrors(res?.data?.errors);
                    } else {
                        ReactNotifications(res?.data?.message || 'An error occurred', utilConstants.getErrorStatus);
                    }
                }
            });
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <CommonModal
            show={show}
            handleClose={onHide}
            handleSave={handleSave}
            mode={modalMode}
            columns={columns} // The columns here define the form fields for CommonModal
            data={modalData}
            handleChange={handleChange}
            errors={errors}
            isChanged={isChanged}
            isSaving={isSaving}
        />
    );
};

export default YearModal;
